import PrimaryButton from 'components/primaryButton'
import { useNavigate } from 'react-router-dom'
import { RejectAudit } from 'assets/icons'

import Logo from 'components/logo'
import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

const RejectedAudit = () => {
  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_cuenta_rechazada' })
  }, [])

  return (
    <div className='flex flex-col h-screen'>
      <header className='shadow-sm w-full h-14 bg-white  md:py-4 flex items-center justify-center'>
        <div className='flex items-center'>
          <Logo showAlways />
        </div>
      </header>
      <div className='mt-20 px-3 h-full w-full max-w-564 mx-auto'>
        <section className='flex text-black flex-col items-center md:max-w-564 mx-auto gap-2 h-full text-center'>
          <div className='py-6'>
            <RejectAudit />
          </div>
          <h1 className='font-bold text-2xl'>
            No pudimos crear una cuenta en función de la información
            proporcionada
          </h1>
          <p className='font-normal mt-6 text-2xl'>Te pedimos disculpas</p>
          <div className='mt-auto mb-8 w-full max-w-lg'>
            <PrimaryButton
              buttonText='Ir al inicio'
              primaryButtonFunction={() => navigate('/')}
            />
          </div>
        </section>
      </div>
    </div>
  )
}

export default RejectedAudit
